import { PlusIcon } from "lucide-react";
import { forwardRef, useState } from "react";

import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useRbac } from "@/providers/RbacProvider";
import { EntityType } from "@/queries";
import { BasicTooltip } from "@/components/ui/Tooltip";
import RequestLogsAgGrid from "@/routes/analytics/RequestLogsAgGrid";

const AddFromRequestHistoryButton = forwardRef(() => {
  const [isInfoDialogOpen, setIsInfoDialogOpen] = useState(false);
  const { isEditDisabled } = useRbac();
  const cannotEditTable = isEditDisabled(EntityType.SMART_TABLE);

  return (
    <BasicTooltip
      content={
        cannotEditTable ? "You don't have permission to add data from request history" : undefined
      }
      shouldShow={cannotEditTable}
    >
      <span>
        <Button
          onClick={() => setIsInfoDialogOpen(true)}
          size="sm"
          variant="outline"
          disabled={cannotEditTable}
        >
          <PlusIcon aria-hidden="true" className="h-4 w-auto pr-1" />
          Add from Request History
        </Button>
        <Dialog onOpenChange={setIsInfoDialogOpen} open={isInfoDialogOpen}>
          <DialogContent className="flex h-[85vh] max-w-[96vw] flex-col overflow-hidden sm:max-w-[1400px]">
            <DialogHeader>
              <DialogTitle>Add from Request History</DialogTitle>
            </DialogHeader>
            <div className="min-h-0 flex-1">
              <RequestLogsAgGrid
                syncUrl={false}
                searchTitle="Requests"
                onAddToTableEnqueueSuccess={() => setIsInfoDialogOpen(false)}
              />
            </div>
          </DialogContent>
        </Dialog>
      </span>
    </BasicTooltip>
  );
});

export default AddFromRequestHistoryButton;
